import authHttpService from '@/services/http/authHttpService.ts'
import emitter from '@/services/emitter.ts'

class UserAuthorizationService {
  public async logout(): Promise<void> {
    await authHttpService.logout().finally(() => {
      emitter.emit('logoutRequired', { reason: 'logout' })
    })
  }
}

export default new UserAuthorizationService()
